import {Component, Inject, Input, PLATFORM_ID} from '@angular/core';
import {ProductListing} from 'src/app/raintree/interface/product-listing/product-listing';
import {FabricProfileItemPl} from '../interface/fabric-profile-item-pl';
import {animate, style, transition, trigger} from '@angular/animations';
import {VolumeDiscountProfileItem} from 'src/app/product-details/interface/volume-discount-profile-item';
import {JWTService} from 'src/app/authentication/jwt.service';
import {RelatedProductList} from 'src/app/product-details/interface/related-product-list';
import {isPlatformBrowser} from '@angular/common';
import {ProductListPriceCalculationService} from '../../service/product-list-price-calculation.service';
import {ApCurrency} from "../../../pipe/enum/ap-currency";
import {WishlistService} from "../../../wishlist/wishlist.service";

@Component({
	selector: 'fb-product-item',
	animations: [
		trigger(
			'enterAnimation', [
			transition(':enter', [
				style({ transform: 'translateX(0)', opacity: 0 }),
				animate('200ms', style({ transform: 'translateX(0)', opacity: 1 }))
			]),
			transition(':leave', [
				style({ transform: 'translateX(0)', opacity: 1 }),
				animate('200ms', style({ transform: 'translateX(0)', opacity: 0 }))
			])
		]
		)
	],
	templateUrl: './product-item.component.html',
	styleUrls: ['./product-item.component.scss']
})
export class ProductItemComponent {

	@Input() productListingData: ProductListing = {} as ProductListing;
	@Input()
	public selectedCurrency: ApCurrency = ApCurrency.INR;
	public fabricORfinished:string = '';
	public isLoggin:boolean = this._jwt.hasValidJWT();
	public fabricProfileItemList: FabricProfileItemPl[] = [];
	public reatOffabricProfileItemList: FabricProfileItemPl[] = [];
	public relatedProductList: RelatedProductList[] = [];
	public excenRelatedProductList: RelatedProductList[] = [];
	public imageCont:string = "";
	public hoverActive: boolean = false;
	public discountedPrice:number = 0;
	public maxDiscount:number = 0;
	public mockupFabricImage: string = '';
	public isMobile: boolean = false;
	public isBrowser: boolean = false;

	constructor(
		private _jwt: JWTService,
		private _productListingPriceCalculation: ProductListPriceCalculationService,
		private _wishlist: WishlistService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	public discount(heighestDiscount: number): void {

		if (heighestDiscount > 0) {
			const discountAmount = (this.productListingData.product.price * heighestDiscount) / 100;
			this.discountedPrice = this.productListingData.product.price - discountAmount;
		} else {
			this.discountedPrice = this.productListingData.product.price;
		}
	}

	public ngOnInit(): void {

		if (this.productListingData.product.productGroup == 'fabric') {
			// this.fabricORfinished = RequestMapperService.GET_PRODUCT_DETAILS_FABRIC;
			this.fabricORfinished = 'fabric-product';
		} else {
			// this.fabricORfinished = RequestMapperService.GET_PRODUCT_DETAILS_FINISH;
			this.fabricORfinished = 'finished-product';
		}

		this.imageCont = this.productListingData.product.heroImage;

		this.productListingData.product.fabricProfile?.fabricProfileItemList.forEach((elm: FabricProfileItemPl, i: number) => {

			if (i <= 2) this.fabricProfileItemList.push(elm);
			else this.reatOffabricProfileItemList.push(elm);

		});

		if(this.productListingData.product.relatedProductList){
			this.productListingData.product.relatedProductList.forEach((elm: RelatedProductList, i: number) => {

				if (i <= 2) this.relatedProductList.push(elm);
				else this.excenRelatedProductList.push(elm);

			});
		}



		if (this.productListingData.product.volumeDiscountProfile) {
			let maxDiscount: VolumeDiscountProfileItem = this.productListingData.product.volumeDiscountProfile!.volumeDiscountProfileItemList.reduce((max, obj) => (max.discount > obj.discount) ? max : obj);
			this.maxDiscount = maxDiscount.discount;

			// this.tempVoulume.forEach()x
			// debugger
			// console.log(maxDiscount.discount)

			// this.discount(maxDiscount.discount);

			this.discountedPrice = this._productListingPriceCalculation.getBulkPrice(this.productListingData,
				this.productListingData.product.productGroup === 'fabric'
			)

		}


		if (this.isBrowser) {

			this.isMobile = window.innerWidth < 999;
		}


	}

	public changeHeroToHoverImage(str: string) {
		if (str == "onover") {
			this.hoverActive = true;
		} else {
			this.hoverActive = false;
		}
		// console.log(this.hoverActive)
	}

	public storeUrl(): void {
		if (this.isBrowser) {
			localStorage.setItem("storeUrl", window.location.href);
		}

	}

	public showMockupImages(image: string): void {
		this.mockupFabricImage = image;
	}

	public hideMockupImages(): void {
		this.mockupFabricImage = '';
	}

	public preventDefaultBehaviour(e: any): void {

		e.preventDefault();
		e.stopPropagation();
	}

	public toggleWishlist(): void {
		this._wishlist.toggle(
			this.productListingData.product.name,
			this.productListingData.product.sku
		);
	}
}
